import { defineStore } from 'pinia'

export const useSendSafelyStore = defineStore(
  'ltc_send_safely',
  () => {
    const hasUpload = ref<Record<string, boolean>>({})

    const getHasUpload = (customerId: string) => hasUpload.value[customerId] ?? false

    const setHasUpload = (customerId: string, value: boolean) => {
      hasUpload.value = {
        ...hasUpload.value,
        [customerId]: value,
      }
    }

    return {
      getHasUpload,
      hasUpload,
      setHasUpload,
    }
  },
  {
    persist: {
      key: `ltc_cc_has_send_safely_upload`,
    },
  },
)
